import { useState } from "react";

import { CallBody, KIND_ICON, KIND_LABEL } from "@/components/pipeline/LeadTimeline";
import { RichText } from "@/components/pipeline/RichText";
import { frDateTime } from "@/components/pipeline/utils";

const FILTERS = [["all", "Tout"], ["calls", "Appels"], ["notes", "Commentaires"], ["comms", "E-mails & SMS"]];
const keep = (f, k) => f === "all" || (f === "calls" ? k.startsWith("call") : f === "notes" ? k === "comment" : k !== "comment" && !k.startsWith("call"));
export const toneOfKind = (k, item) => (k.startsWith("call") ? (item?.answered === false ? "tomato" : item?.answered ? "pine" : "butter") : k.startsWith("email") ? "pine" : k.startsWith("sms") ? "tomato" : "plain");

const Long = ({ text }) => {
  const [open, setOpen] = useState(false);
  const long = text.length > 420 || text.split("\n").filter((l) => l.trim()).length > 7;
  return (
    <>
      <RichText className={`pl-tl-text${long && !open ? " ldx-clamp" : ""}`} text={text} />
      {long && <button type="button" className="pl-link ldx-more-btn" onClick={() => setOpen(!open)} data-testid="timeline-expand">{open ? "Réduire" : "Afficher tout"}</button>}
    </>
  );
};

// Historique complet en une seule liste ; les pastilles servent de filtre
const DAY = (iso) => new Date(iso).toLocaleDateString("fr-CA", { timeZone: "Europe/Paris" });
const dayLabel = (key) => {
  const today = DAY(new Date().toISOString());
  const y = DAY(new Date(Date.now() - 864e5).toISOString());
  if (key === today) return "Aujourd'hui";
  if (key === y) return "Hier";
  const t = new Date(`${key}T12:00:00`).toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
  return t.charAt(0).toUpperCase() + t.slice(1);
};
// Regroupe les éléments (déjà triés du plus récent au plus ancien) par journée
const byDay = (list) => list.reduce((acc, i) => { const k = i.at ? DAY(i.at) : "—"; const last = acc[acc.length - 1]; if (last && last.key === k) last.items.push(i); else acc.push({ key: k, items: [i] }); return acc; }, []);

export const LeadHistory = ({ items, remindDate, onApplyDate }) => {
  const [f, setF] = useState("all");
  const [max, setMax] = useState(25);
  const all = items.filter((i) => keep(f, i.kind));
  const list = all.slice(0, max);
  return (
    <section className="card ldx-hist" data-testid="lead-timeline">
      <header className="ldx-hist__head">
        <h2 className="card__title">Historique</h2>
        <div className="ldx-filters" role="group" aria-label="Filtrer l'historique">
          {FILTERS.map(([k, l]) => {
            const n = items.filter((i) => keep(k, i.kind)).length;
            return <button key={k} type="button" className="chip" aria-pressed={f === k} onClick={() => { setF(k); setMax(25); }} data-testid={`timeline-tab-${k}`}>{l} <em>{n}</em></button>;
          })}
        </div>
      </header>
      <ol className="ldx-tl">
        {byDay(list).map((g) => [
          <li key={`d-${g.key}`} className="ldx-tl__day" data-testid={`timeline-day-${g.key}`}><span>{g.key === "—" ? "Sans date" : dayLabel(g.key)}</span><em>{g.items.length} élément{g.items.length > 1 ? "s" : ""}</em></li>,
          ...g.items.map((i) => {
          const Icon = KIND_ICON[i.kind] || KIND_ICON.comment;
          return (
            <li key={i.id} id={`tl-${i.id}`} className={`ldx-tl__item ldx-tone-${toneOfKind(i.kind, i)}`} data-testid={`timeline-item-${i.id}`}>
              <span className="ldx-tl__ico"><Icon size={14} /></span>
              <div className="ldx-tl__body">
                <p className="ldx-tl__head"><b>{i.kind === "comment" ? "Commentaire" : i.title}</b><span>{i.kind === "comment" ? i.title : i.who || KIND_LABEL[i.kind]}</span><time>{frDateTime(i.at)}</time></p>
                {i.kind.startsWith("call") ? <CallBody item={i} onApplyDate={onApplyDate} remindDate={remindDate} /> : i.excerpt && <Long text={i.excerpt} />}
              </div>
            </li>
          );
        }),
        ])}
        {!list.length && <li className="ldx-empty" data-testid="timeline-empty">Rien pour l'instant.</li>}
      </ol>
      {all.length > max && <button type="button" className="link-button ldx-hist__more" onClick={() => setMax(max + 25)} data-testid="timeline-more">Afficher 25 éléments de plus ({all.length - max} restants)</button>}
    </section>
  );
};
